var React = require('react');

function MoviesInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12 9.125L16 6v8l-4-2.875V13a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v2.125zM8.5 6a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5zM3 6a2 2 0 1 1 0-4 2 2 0 0 1 0 4z","fill":"currentColor","fillRule":"evenodd"}));
}

MoviesInline.defaultProps = {"viewBox":"0 0 16 16"};

module.exports = MoviesInline;

MoviesInline.default = MoviesInline;
